import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-locked-comments',
  templateUrl: './locked-comments.component.html',
  styleUrls: ['./locked-comments.component.scss'],
})
export class LockedCommentsComponent {
  @Input() isLocked: boolean = true;
  @Output() unlock = new EventEmitter<void>();

  unlockComments() {
    // Only emit when specifically attempting to unlock
    console.log('User explicitly chose to unlock comments');
    this.unlock.emit();
  }
}

